<template>
<div>
  <v-snackbar
      :value="hasError"
      top
      :multi-line="true"
      :timeout="-1"
    >
    <span v-html="error"></span>
    <v-btn
      class="ml-5"
      color="error"
      @click="clearError"
    >
      {{ $t('Close') }}
    </v-btn>
  </v-snackbar>
  <v-snackbar
      :value="hasInfo"
      color="teal"
      bottom=""
      :multi-line="true"
      :timeout="-1"
    >
    <span v-html="info"></span>
    <v-btn
      class="ml-5"
      color="info"
      @click="clearInfo"
    >
      {{ $t('Close') }}
    </v-btn>
  </v-snackbar>
</div>

</template>
<script>
import * as errorStore from '../store/error'

export default {
  setup () {
    const {
      state: { error, hasError, info, hasInfo },
      clearError,
      clearInfo
    } = errorStore.useStore()

    return {
      error,
      hasError,
      info,
      hasInfo,
      clearError,
      clearInfo
    }
  }
}
</script>
